export default __webpack_public_path__ + "static/media/calendar_screenshot.d48461f6.png";